<template>
  <v-container>
    <!-- Agrupación principal por pmp_tap_desapo -->
    <v-expansion-panels flat v-model="expandedPanels">
      <v-expansion-panel v-for="(grupo, grupoIndex) in groupedByTipoAporte" :key="grupo.tipoAporte"
        style="border: 1px solid #f0f0f0; border-radius: 0px;">
        <v-expansion-panel-header hide-actions class="ma-0">
          <template v-slot:default="{ open }">
            <div class="font-weight-bold text-body-1">
              <v-icon :class="{ 'rotate-icon': open }" color="primary" class="mr-2">
                mdi-chevron-down
              </v-icon>
              {{ grupo.tipoAporte.toUpperCase() }}
            </div>
            <v-col cols="4" class="my-0 py-0 d-flex justify-end align-center">
              <div class="font-weight-bold" :class="($vuetify.breakpoint.xsOnly) ? 'text-caption' : 'text-body-1'"
                v-if="tipo == 'vencido'">
                TOTAL ADEUDADO:

                <v-chip :color="getColor" dark label>
                  {{ formatMoney(grupo.totalDeuda) }}
                </v-chip>
              </div>
              <div class="font-weight-bold mr-2" v-if="tipo == 'noVencido'">
                PROXIMO A VENCER:
                <v-chip :color="getColor" dark label>
                  {{ formatMoney(grupo.proximoVencer) }}
                </v-chip>
              </div>
              <div class="font-weight-bold mr-2" v-if="tipo == 'debitoAuto'">
                PROXIMO A DEBITAR:
                <v-chip :color="getColor" dark label>
                  {{ formatMoney(grupo.proximoDebitar) }}
                </v-chip>
              </div>
            </v-col>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- Agrupación secundaria por pmp_anio_convenio -->
          <v-expansion-panels class="pa-3" flat v-model="expandedSubPanels[grupoIndex]">
            <v-expansion-panel v-for="(anioGrupo, anioIndex) in grupo.aniosConvenio" :key="anioGrupo.anioConvenio">
              <v-expansion-panel-header class=" d-flex flex-row justify-self-start text-body-1" hide-actions>
                <template v-slot:default="{ open }">
                  <div>
                    <v-icon :class="{ 'rotate-icon': open }">
                      mdi-chevron-down
                    </v-icon>
                    <!--       <v-icon color="primary darken-2">mdi-circle-medium</v-icon> -->
                    {{ getLabel(grupo.tipoAporte) }}
                    <span class="font-weight-bold primary--text text-body-1 ml-2"> {{ anioGrupo.anioConvenio }}</span>
                  </div>
                </template>
              </v-expansion-panel-header>
              <!-- <v-divider></v-divider> -->
              <v-expansion-panel-content>
                <v-data-table v-if="!$device.isMobile && !$vuetify.breakpoint.xsOnly" :headers="filteredHeaders"
                  :items="anioGrupo.mesesCuotas" hide-default-footer item-key="pmp_id" :show-select="showSelect"
                  :items-per-page='-1' checkbox-color="primary" disabled-pagination disable-items-per-page="true"
                  v-model="selected" disable-sort no-data-text="No hay aportes a mostrar"
                  :item-disabled="isItemDisabled">
                  <template v-slot:item.pmp_observaciones="{ item }">
                    <div class="font-weight-bold orange--text text--darken-2"> {{ texto.toUpperCase() }}
                    </div>
                    <!-- {{ item.pmp_observaciones }} -->
                  </template>
                  <template v-slot:item.pmp_apagar="{ item }">
                    <v-chip :color="getColor" :dark="(item.pmp_observaciones !== '')" label
                      class="align-center justify-center font-weight-regular">
                      {{ formatMoney(item.pmp_apagar) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn icon class="pa-4" color="primary" @click="descargarBoleta(item)">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
                <!-- Vista personalizada para pantallas pequeñas -->
                <div v-else>
                  <v-card v-for="item in anioGrupo.mesesCuotas" :key="item.pmp_id"
                    class="mb-2 px-6 py-2 elevation-0 rounded-0">
                    <v-row align="center">
                      <!-- Checkbox de selección -->
                      <v-col cols="1" v-if="showSelect">
                        <v-checkbox v-model="selected" :value="item" color="primary" hide-details
                          class="ma-0 pa-0"></v-checkbox>
                      </v-col>

                      <!-- Concepto + Mes -->
                      <v-col cols="7">
                        <div class="font-weight-bold text-body-1">
                          {{ grupo.tipoAporte.toUpperCase() }}
                          <span v-if="getLabel(grupo.tipoAporte) === 'AÑO'"> {{ getMonthName(item.pmp_mes_cuota)
                          }}</span>
                        </div>
                      </v-col>

                      <!-- Monto -->
                      <v-col cols="4" class="d-flex justify-end">
                        <v-chip :color="getColor" dark label class="font-weight-regular text-subtitle-2">
                          {{ formatMoney(item.pmp_apagar) }}
                        </v-chip>
                      </v-col>
                    </v-row>

                    <v-row>
                      <!-- Mes/Cuota -->
                      <v-col cols="12">
                        Mes/Cuota:
                        <div class="d-inline font-weight-bold">
                          {{ item.pmp_mes_cuota }}
                        </div>
                      </v-col>

                      <!-- Fecha de vencimiento -->
                      <v-col cols="12">
                        Fecha de vencimiento:
                        <div class="d-inline font-weight-bold">
                          {{ formatDate(item.pmp_fecha_vencimiento) }}
                        </div>
                      </v-col>
                    </v-row>

                    <!-- Botón descargar -->
                    <v-row class="mt-2">
                      <v-col cols="12">
                        Descargar boleta
                        <v-btn icon color="primary" @click="descargarBoleta(item)">
                          <v-icon>mdi-download</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col
                        v-if="anioGrupo.mesesCuotas.length > 1 && item !== anioGrupo.mesesCuotas[anioGrupo.mesesCuotas.length - 1]">
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      open: false,
      texto: "El importe será debitado automaticamente",
      expandedPanels: 0, // Expande el primer panel principal al cargar
      expandedSubPanels: [0], // Expande el primer sub-panel para cada grupo
      selected: [],  // Array para manejar los elementos seleccionados
      monthNames: [
        '', 'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
        'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'
      ]
    }
  },
  computed: {
    //...mapGetters('boletas', ['conceptosVencidos', 'conceptosNoVencidos']),
    ...mapGetters('auth', ['nroafi']),

    // Cálculo del total de los conceptos seleccionados
    totalSeleccionado() {
      return this.selected.reduce((total, item) => total + item.pmp_apagar, 0);
    },

    filteredHeaders() {
      if (!this.showSelect) {
        return this.headers.filter(header => header.value !== 'data-table-select');
      }
      return this.headers;
    },

    getColor() {
      const tipoMap = {
        vencido: 'error',
        noVencido: 'primary'
      }
      return tipoMap[this.tipo]
    },

    // Agrupamos los conceptos
    groupedByTipoAporte() {
      const grouped = this.items.reduce((result, item) => {
        const tipoAporte = item.pmp_tap_desapo;
        if (!result[tipoAporte]) {
          result[tipoAporte] = { tipoAporte, aniosConvenio: {}, totalDeuda: 0, proximoDebitar: 0, proximoVencer: 0 };
        }
        const anioConvenio = item.pmp_anio_convenio;
        if (!result[tipoAporte].aniosConvenio[anioConvenio]) {
          result[tipoAporte].aniosConvenio[anioConvenio] = { anioConvenio, mesesCuotas: [] };
        }
        result[tipoAporte].aniosConvenio[anioConvenio].mesesCuotas.push(item);
        result[tipoAporte].totalDeuda += item.pmp_apagar; // Sumar el monto al total

        // Calculate the "próximo a debitar" as the first unpaid item
        if (result[tipoAporte].proximoDebitar === 0 && item.pmp_apagar > 0) {
          result[tipoAporte].proximoDebitar = item.pmp_apagar;
        }

        // Calculate the "próximo a vencer" as the first unpaid item with a due date
        if (result[tipoAporte].proximoVencer === 0 && item.pmp_apagar > 0 && item.pmp_fecha_vencimiento) {
          result[tipoAporte].proximoVencer = item.pmp_apagar;
        }

        return result;
      }, {});
      return Object.values(grouped).map(grupo => ({
        tipoAporte: grupo.tipoAporte,
        aniosConvenio: Object.values(grupo.aniosConvenio),
        totalDeuda: grupo.totalDeuda, // Mantener el total calculado
        proximoDebitar: grupo.proximoDebitar,
        proximoVencer: grupo.proximoVencer
      }));
    }
  },
  methods: {
    ...mapActions('boletas', ['imprimirPdf']),

    formatMoney(value) {
      return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
    },
    downloadItem(item) {
      // Aquí agregar la lógica para descargar el item
      alert(`Descargando item: ${item.pmp_id}`);
    },
    getMonthName(monthNumber) {
      return this.monthNames[parseInt(monthNumber)] || monthNumber;
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      // Asumiendo formato DD/MM/YYYY o similar
      return dateString;
    },

    //terminar mañana
    descargarBoleta(item) {
      const obj = {
        tipo_aporte: item.pmp_tipapo,
        tipo_frm: 1,
        nro_afi_add: this.nroafi,
        mescuota: item.pmp_mes_cuota,
        anioconv: item.pmp_anio_convenio,
        es_portal: 1,
        nro_afi_listado: [this.nroafi + `|` + item.pmp_mes_cuota + `/` + item.pmp_anio_convenio]
      }
      this.imprimirPdf(obj)
    },

    // Determinar si mostrar "Año" o "Convenio" según el tipo de aporte
    getLabel(tipoAporte) {
      const tiposConAnio = ['APORTE MENSUAL', 'EMERGENCIAS MEDICAS', 'PLAN JOVEN'];
      return tiposConAnio.includes(tipoAporte.toUpperCase()) ? 'AÑO' : 'CONVENIO';
    },
  },

  watch: {
    selected: {
      handler() {
        this.$emit('update-total', this.totalSeleccionado);
      },
      deep: true
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    tipo: {
      type: String,
      required: true
    },
    showSelect: {
      type: Boolean,
      required: false,
      default: true,
    }
  }
};
</script>

<style>
/* Agrega algún estilo personalizado si es necesario */
.icono-expand {
  margin-left: auto;
}

.rotate-icon {
  transition: transform 0.3s ease;
  transform: rotate(-180deg);
}
</style>